// Mock data for TM Construction website - Real data from tandmbuilders.co.uk

export const mockData = {
  company: {
    name: "TM Construction",
    tradingName: "T&M Construction",
    registeredName: "T&M Builders Suffolk LTD",
    companyNumber: "14672875",
    vatNumber: "495724938",
    placeOfRegistration: "England and Wales",
    tagline: "Leading Construction and Renovation Specialists in Suffolk, Essex, and London",
    phone: "+44 0333 335 5532",
    email: "info@tandmbuilders.co.uk",
    address: "Ipswich, UK",
    social: {
      linkedin: "https://www.linkedin.com/company/t-mbuilders/",
      facebook: "https://www.facebook.com/share/1C2eKM9Ptu/?mibextid=wwXIfr",
      instagram: "https://www.instagram.com/tm_constructionltd?igsh=MWVieHNjdDFtNHNvdA=="
    }
  },

  services: [
    {
      id: 1,
      title: "Kitchen Renovations",
      description: "Complete kitchen transformations with high-quality fixtures, modern designs, and expert installation.",
      icon: "ChefHat"
    },
    {
      id: 2,
      title: "Bathroom Installations",
      description: "Professional bathroom renovations and installations tailored to your style and requirements.",
      icon: "Bath"
    },
    {
      id: 3,
      title: "Extensions & Loft Conversions",
      description: "Expand your living space with expertly designed and constructed extensions and loft conversions.",
      icon: "Home"
    },
    {
      id: 4,
      title: "Property Refurbishment",
      description: "Complete property transformations including rewiring, replastering, and structural modifications.",
      icon: "Hammer"
    },
    {
      id: 5,
      title: "Painting & Decorating",
      description: "Professional painting services using premium quality paints for long-lasting, beautiful finishes.",
      icon: "PaintBucket"
    },
    {
      id: 6,
      title: "General Maintenance",
      description: "Comprehensive property maintenance services to keep your home or business in excellent condition.",
      icon: "Wrench"
    },
    {
      id: 7,
      title: "Landscaping",
      description: "Transform your outdoor spaces with professional landscaping, garden design, and maintenance services.",
      icon: "Trees"
    },
    {
      id: 8,
      title: "Cleaning Services",
      description: "Professional deep cleaning for construction projects, renovations, and general property maintenance.",
      icon: "Sparkles"
    }
  ],

  projects: [
    {
      id: 1,
      title: "Residential Renovation - Capel St. Mary",
      category: "Residential",
      location: "Capel St. Mary, Ipswich",
      description: "Full kitchen, living room, and stair repainting using premium quality paints for long-lasting finish.",
      image: "https://tandmbuilders.co.uk/pro1.jpeg"
    },
    {
      id: 2,
      title: "Whole House Refurbishment - Ipswich",
      category: "Residential",
      location: "Back Hamlet, Suffolk, Ipswich",
      description: "Full property transformation including wall removal, Velux installation, rewiring, replastering, and bathroom reconfiguration.",
      image: "https://tandmbuilders.co.uk/pro2.jpeg"
    },
    {
      id: 3,
      title: "Partial House Painting - Colchester",
      category: "Residential",
      location: "Colchester, Essex",
      description: "Wallpaper removal from the hall, repainting 3 bedrooms, hall, handrail including skirting boards, doorframes, and doors varnishing.",
      image: "https://tandmbuilders.co.uk/pro3.20.jpg"
    },
    {
      id: 4,
      title: "Wallpaper Removal and Repainting",
      category: "Residential",
      location: "Whitton, Ipswich",
      description: "Wallpaper removal and repainting of 2 bedrooms using premium quality paints for long-lasting finish.",
      image: "https://tandmbuilders.co.uk/pro4.1.jpg"
    },
    {
      id: 5,
      title: "Single Room Colour Change",
      category: "Residential",
      location: "Needham Market, Suffolk",
      description: "Wallpaper removal and repainting of 1 bedroom using premium quality paints for long-lasting finish.",
      image: "https://tandmbuilders.co.uk/pro5.1.jpg"
    },
    {
      id: 6,
      title: "Kitchen & Living Space Renovation",
      category: "Residential",
      location: "Ipswich, Suffolk",
      description: "Complete renovation of kitchen and living areas with modern finishes and quality craftsmanship.",
      image: "https://images.unsplash.com/photo-1556912173-3bb406ef7e77?w=800&h=600&fit=crop"
    }
  ],

  testimonials: [
    {
      id: 1,
      name: "Sarah Mitchell",
      role: "Homeowner, Capel St. Mary",
      content: "TM Construction did an amazing job repainting our kitchen and living areas. The finish is perfect and they were professional throughout. Highly recommended!",
      rating: 5
    },
    {
      id: 2,
      name: "James Robertson",
      role: "Homeowner, Ipswich",
      content: "The team completely transformed our property with a full refurbishment. The quality of work is exceptional and they completed everything on schedule.",
      rating: 5
    },
    {
      id: 3,
      name: "Emma Thompson",
      role: "Homeowner, Colchester",
      content: "From wallpaper removal to painting multiple rooms, the team was fantastic. They took great care with every detail and the results are beautiful.",
      rating: 5
    },
    {
      id: 4,
      name: "Michael Davis",
      role: "Property Owner, Suffolk",
      content: "Professional, reliable, and delivered excellent results. TM Construction has become our trusted contractor for all property maintenance and renovation needs.",
      rating: 5
    }
  ],

  serviceAreas: [
    "Ipswich",
    "Capel St. Mary",
    "Needham Market",
    "Colchester",
    "Whitton",
    "Back Hamlet",
    "Suffolk",
    "Essex",
    "London"
  ],

  team: [
    {
      id: 1,
      name: "Project Management Team",
      role: "Construction Specialists",
      description: "Over a decade of experience in construction and renovation"
    }
  ],

  stats: [
    {
      number: "10+",
      label: "Years Experience"
    },
    {
      number: "500+",
      label: "Projects Completed"
    },
    {
      number: "100%",
      label: "Quality Guaranteed"
    },
    {
      number: "3",
      label: "Counties Covered"
    }
  ]
};
